// removed by extract-text-webpack-plugin
module.exports = {"supporter-message-box":"_3ZqFd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankingDonors/ThankingDonors.scss
// module id = ./src/components/ThankingDonors/ThankingDonors.scss
// module chunks = 5